module.exports = __webpack_public_path__ + "img/90.f352f73e.jpg";